import { render, staticRenderFns } from "./ModalAdminJukuAdd.vue?vue&type=template&id=3e1c3768&scoped=true&lang=pug&"
import script from "./ModalAdminJukuAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminJukuAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminJukuAdd.vue?vue&type=style&index=0&id=3e1c3768&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1c3768",
  null
  
)

export default component.exports